export const SEGMENT = {
    TAP_BTN: 'tap_btn_CTA_widget',
    OTP_ENTERED: 'otp_entered',
    VIEW_PAGE: 'view_page',
    TAB_BTN_ACKO: 'tap_btn_acko_app',
    SIT_KEY: '7c7ed18d-afea-409e-9306-91368490a73a'
}
